import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntro from "./HeaderIntro";
import NewsLetter from "./NewsLetter";
export class GstAudit extends Component {
  render() {
    return (
      <div>
        <Header />
        <HeaderIntro />
        <section id="contact" style={{ backgroundColor: "#f3f9fd" }}>
          <div className="container">
            <div class="container-fluid" data-aos="fade-up">
              <div class="section-header">
                <h3>GST Audit</h3>
                <p>
                  Cliptax not only assists you in registering and filing returns
                  but also provides services relating to GST audit.It is backed
                  by our Expert GST Consultants catering your needs related to
                  GST. All information will be updated whenever the need arises.
                </p>
              </div>
            </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default GstAudit;
